import http_request from './http_request'
import config from 'config'

function getGame(gameUID) {
	return http_request.get(`${config.slides}slide/game/${gameUID}`)
		.withExternalJwt()
		.send()
}

function addQuestion(gameUID) {
	return http_request.post(`${config.slides}slide/game/${gameUID}/activity`)
		.withExternalJwt()
		.send({
			type: 'question',
		})
}

function saveActivity(game, activity) {
	return http_request.put(`${config.slides}slide/game/${game.uid}/activity/${activity.serverId}`)
		.withExternalJwt()
		.send({
			text: activity.text,
			answers: activity.answers,
			timer: activity.timer,
		})
}

function deleteActivity(gameUID, activityUID) {
	return http_request.delete(`${config.slides}slide/game/${gameUID}/activity/${activityUID}`)
		.withExternalJwt()
		.send()
}

function saveGame(gameUID) {
	return http_request.put(`${config.slides}slide/game/${gameUID}`)
		.withExternalJwt()
		.send()
}

function sortQuestions(gameUID, activities) {
	return http_request.put(`${config.slides}slide/game/${gameUID}/sort`)
		.withExternalJwt()
		.send({
			activities,
		})
}

function duplicateQuestion(gameUID, activityUID) {
	return http_request.post(`${config.slides}slide/game/${gameUID}/activity/${activityUID}/duplicate`)
		.withExternalJwt()
		.send()
}


function deleteQuestionReferenceMedia(gameUID, questionUid) {
	return http_request.delete(`${config.slides}slide/game/${gameUID}/question/${questionUid}/asset`)
		.withExternalJwt()
		.send()
}

export default {
	getGame,
	addQuestion,
	saveActivity,
	deleteActivity,
	saveGame,
	sortQuestions,
	duplicateQuestion,
	deleteQuestionReferenceMedia,
}
